import * as R from 'ramda'
import vue from 'vue'
import actions from './actions'
import createBaseState, {
  createBaseFees,
  createGradesObject
} from './createBaseState'
import getters from './getters'
import * as types from './types.js'

const state = createBaseState()

const mutations = {
  [types.SET_LOADING](state, loading) {
    state.view_loading = loading
  },
  [types.HIDE_NOTIFICATION](state) {
    state.notification.show = false
  },
  [types.SET_SELECTED_COUNTRY](state, country_code) {
    state.selectedCountry = country_code
  },
  [types.SET_SELECTED_PRODUCT](state, product) {
    state.selectedProduct = product
  },
  [types.SET_EDIT_MODE](state, value) {
    state.edit_mode = value
  },
  [types.STATE_MODIFIED](state, value = true) {
    state.modified = value
  },
  [types.SET_FEE_VALUE](state, { value, grade, country }) {
    state.modified = true
    const fees = state.pricing[state.selectedProduct][country].fees

    fees[grade] = {
      product_type: state.selectedProduct,
      country_code: country,
      grade,
      fee: value
    }
  },
  [types.SET_CUSTOM_FEE_VALUE](state, { value, grade, country, account_id }) {
    state.modified = true
    const custom_fees =
      state.pricing[state.selectedProduct][country].custom_fees[account_id]

    custom_fees[grade] = {
      product_type: state.selectedProduct,
      country_code: country,
      grade,
      fee: value,
      account_id
    }
  },
  [types.SET_PRICING_FEES](state, fees_response) {
    state.raw_response = fees_response

    const feesObject = createBaseFees()

    fees_response.fees.forEach((element) => {
      const prod = element.product_type
      const country = element.country_code

      if (!feesObject.pricing[prod][country]) {
        feesObject.pricing[prod][country] = {}
        feesObject.pricing[prod][country].fees = createGradesObject(country)
      }

      feesObject.pricing[prod][country].fees[element.grade] = element
    })

    fees_response.custom_fees
      ? fees_response.custom_fees.forEach((element) => {
          const prod = element.product_type
          const country = element.country_code

          if (!feesObject.pricing[prod][country]) {
            feesObject.pricing[prod][country] = {}
          }
          if (!feesObject.pricing[prod][country].custom_fees) {
            feesObject.pricing[prod][country].custom_fees = {}
          }
          if (
            !feesObject.pricing[prod][country].custom_fees[element.account_id]
          ) {
            feesObject.pricing[prod][country].custom_fees[element.account_id] =
              createGradesObject(country)
          }
          feesObject.pricing[prod][country].custom_fees[
            element.account_id
          ].account_name = element.account_name
          feesObject.pricing[prod][country].custom_fees[element.account_id][
            element.grade
          ] = element
        })
      : []

    state.pricing = feesObject.pricing
    state.modified = false

    if (!state.selectedCountry)
      state.selectedCountry = Object.keys(
        state.pricing[state.selectedProduct]
      )[0]
  },
  [types.ADD_CUSTOM_FEE](state, { id, name }) {
    const clone = JSON.parse(JSON.stringify(state))

    if (
      !clone.pricing[clone.selectedProduct][clone.selectedCountry].custom_fees
    ) {
      clone.pricing[clone.selectedProduct][clone.selectedCountry].custom_fees =
        {}
    }

    clone.pricing[clone.selectedProduct][clone.selectedCountry].custom_fees[
      id
    ] = {
      ...createGradesObject(clone.selectedCountry),
      account_id: id,
      account_name: name
    }

    state = Object.assign(state, clone)
  },
  [types.REMOVE_CUSTOM_FEE](state, account_id) {
    state.modified = true
    const clone = JSON.parse(JSON.stringify(state))

    delete clone.pricing[clone.selectedProduct][clone.selectedCountry]
      .custom_fees[account_id]

    state = Object.assign(state, clone)
  },
  [types.ADD_COUNTRY](state, country) {
    vue.set(state.pricing[state.selectedProduct], country, {
      fees: createGradesObject(country)
    })
  },
  [types.REMOVE_COUNTRY](state, country) {
    const Obj = R.clone(state.pricing[state.selectedProduct])
    delete Obj[country]
    state.pricing[state.selectedProduct] = Obj
  },
  [types.SET_ACCOUNTS](state, payload) {
    state.accounts = payload
  },
  [types.SHOW_CUSTOM_FEE_DIALOG](state) {
    state.custom_fee_dialog.show = true
  },
  [types.HIDE_CUSTOM_FEE_DIALOG](state) {
    state.custom_fee_dialog.show = false
  },
  [types.SET_CUSTOM_FEE_DIALOG_OPTIONS](state, options) {
    state.custom_fee_dialog = Object.assign(state.custom_fee_dialog, options)
  },
  [types.SET_SUPPORTED_COUNTRIES](state, countries) {
    state.available_countries = countries
  }
}

export default {
  actions,
  getters,
  mutations,
  state
}
